import React from "react";
import { View, StyleSheet } from "react-native";
import { MaterialCommunityIcons } from "@expo/vector-icons";
import { ThemedText } from "@/components/ThemedText";
import { useTheme } from "@/hooks/useTheme";
import { LocationType } from "@/types";
import { ShiftLocationType } from "@/types/db/shifts";

type LocationDisplayProps = {
  location?: LocationType | ShiftLocationType;
  compact?: boolean;
};

export function LocationDisplay({ location, compact = false }: LocationDisplayProps) {
  const { colors } = useTheme();

  const locationText = location ? location.name || location.address?.street || "Location" : "-";

  return (
    <View style={styles.locationRow}>
      <MaterialCommunityIcons name="map-marker-outline" size={compact ? 10 : 12} color={colors.placeholder} />
      <ThemedText style={[styles.locationText, compact && styles.textCompact]} numberOfLines={1}>
        {locationText}
      </ThemedText>
    </View>
  );
}

const styles = StyleSheet.create({
  locationRow: {
    flexDirection: "row",
    alignItems: "center",
    gap: 4,
  },
  locationText: {
    fontSize: 11,
    opacity: 0.8,
    flex: 1,
  },
  textCompact: {
    fontSize: 9,
  },
});
